import {
  FilledInput,
  FormControl,
  FormHelperText,
  InputAdornment,
} from "@mui/material";
import styled from "styled-components";
import { theme } from "../../../../../helpers/theme";

interface PackageTypeSummaryProps {
  packageType: string;
  formik: any;
}

const PackageTypeSummary = ({
  packageType,
  formik,
}: PackageTypeSummaryProps) => {
  return (
    <PackageTypeSummaryContainer>
      <PackageTypeName>{`${packageType}:`}</PackageTypeName>
      <FormControl sx={{ m: 1, width: "20ch" }} variant="filled">
        <StyledSummaryInput
          id="quantity"
          name="quantity"
          value={formik.values.quantity}
          onChange={formik.handleChange}
          error={formik.touched.quantity && Boolean(formik.errors.quantity)}
          onBlur={formik.handleBlur}
          type="number"
          endAdornment={<InputAdornment position="end">szt.</InputAdornment>}
          aria-describedby="filled-quantity-helper-text"
          inputProps={{
            "aria-label": "quantity",
          }}
        />
        <FormHelperText id="filled-quantity-helper-text">Ilość</FormHelperText>
      </FormControl>
      <FormControl sx={{ m: 1, width: "20ch" }} variant="filled">
        <StyledSummaryInput
          id="weight"
          name="weight"
          value={formik.values.weight}
          onChange={formik.handleChange}
          error={formik.touched.weight && Boolean(formik.errors.weight)}
          onBlur={formik.handleBlur}
          type="number"
          endAdornment={<InputAdornment position="end">kg/szt.</InputAdornment>}
          aria-describedby="filled-weight-helper-text"
          inputProps={{
            "aria-label": "weight",
          }}
        />
        <FormHelperText id="filled-weight-helper-text">Waga</FormHelperText>
      </FormControl>

      <FormControl sx={{ m: 1, width: "20ch" }} variant="filled">
        <StyledSummaryInput
          id="length"
          name="length"
          value={
            packageType === "Paleta EUR"
              ? formik.values.lengthEUR
              : formik.values.lengthEUR2
          }
          disabled={true}
          type="number"
          endAdornment={<InputAdornment position="end">mm</InputAdornment>}
          aria-describedby="filled-length-helper-text"
          inputProps={{
            "aria-label": "length",
          }}
        />
        <FormHelperText id="filled-length-helper-text">Długoość</FormHelperText>
      </FormControl>
      <FormControl sx={{ m: 1, width: "20ch" }} variant="filled">
        <StyledSummaryInput
          id="width"
          name="width"
          value={
            packageType === "Paleta EUR"
              ? formik.values.widthEUR
              : formik.values.widthEUR2
          }
          disabled={true}
          type="number"
          endAdornment={<InputAdornment position="end">mm</InputAdornment>}
          aria-describedby="filled-width-helper-text"
          inputProps={{
            "aria-label": "width",
          }}
        />
        <FormHelperText id="filled-width-helper-text">Szerokość</FormHelperText>
      </FormControl>

      <FormControl sx={{ m: 1, width: "20ch" }} variant="filled">
        <StyledSummaryInput
          id="height"
          name="height"
          value={1600}
          disabled={true}
          type="number"
          endAdornment={<InputAdornment position="end">mm</InputAdornment>}
          aria-describedby="filled-height-helper-text"
          inputProps={{
            "aria-label": "height",
          }}
        />
        <FormHelperText id="filled-height-helper-text">Wysokość</FormHelperText>
      </FormControl>
      <SummarySection>
        <SummarySectionInfo>
          {`Powierzchnia łącznie: `}
          <SummarySectionValue>
            {packageType === "Paleta EUR"
              ? (formik.values.lengthEUR *
                  formik.values.widthEUR *
                  formik.values.quantity) /
                1000000
              : (formik.values.lengthEUR2 *
                  formik.values.widthEUR2 *
                  formik.values.quantity) /
                1000000}
          </SummarySectionValue>
          {` m2`}
        </SummarySectionInfo>

        <SummarySectionInfo>
          {`Waga łącznie: `}
          <SummarySectionValue>
            {(formik.values.quantity * formik.values.weight) / 1000}
          </SummarySectionValue>
          {` t`}
        </SummarySectionInfo>
      </SummarySection>
    </PackageTypeSummaryContainer>
  );
};

export default PackageTypeSummary;

const PackageTypeSummaryContainer = styled.div`
  width: 94%;
  flex-wrap: wrap;

  @media (max-width: 414px) {
    justify-content: center;
  }

  display: flex;
  justify-content: space-between;
  background-color: white;
  padding: 3%;
  border-radius: 10px;
`;
const PackageTypeName = styled.span`
  font-family: ${theme.fonts.interMedium};
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  height: 40px;
  margin: 8px;
  width: 20ch;
  display: flex;
  width: 160px;
  align-items: flex-end;
`;
const SummarySection = styled.div`
  margin-top: 20px;
  width: 94%;
  display: flex;
  height: 56px;
  gap: 20px;
  align-items: center;
  padding: 0 3%;
  border: 1px solid ${theme.colors.blue01_active};
  border-radius: 8px;
`;
const SummarySectionInfo = styled.span`
  color: ${theme.colors.blue01_active};
  font-family: ${theme.fonts.interMedium};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`;
const SummarySectionValue = styled(SummarySectionInfo)`
  font-weight: 700;
`;

const StyledSummaryInput = styled(FilledInput)(({ theme }) => ({
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    display: "none",
  },
  "& input[type=number]": {
    MozAppearance: "textfield",
  },
}));
